/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPBANKNAME = {
    AbsaBank: '1',
    AfricanBank: '2',
    AlbarakaBank: '3',
    BankZero: '4',
    BidvestBank: '5',
    CapitecBank: '6',
    Citibank: '7',
    DiscoveryBank: '8',
    FinbondMutualBank: '9',
    GrindrodBank: '10',
    FirstNationalBankFnb: '11',
    HsbcBank: '12',
    InvestecBank: '13',
    JpMorganChaseBank: '14',
    CapitecBusinessBankFormerlyMercantileBank: '15',
    NedbankLimitedSouthAfrica: '16',
    NedbankIncorporatingBoe: '17',
    NedbankIncorporatingFbc: '18',
    PeoplesMortgageBank: '19',
    PeoplesBankIncludingNbs: '20',
    OlympusMobile: '21',
    OldMutualBank: '22',
    SouthAfricanPostbankSocLtd: '23',
    SasfinBank: '24',
    StandardBankOfSouthAfrica: '25',
    StandardCharteredBank: '26',
    StateBankOfIndia: '27',
    TymeDigital: '28',
    UbankLimited: '29',
    VbsMutualBank: '30',
    BankOfAthens: '32',
    HbzBank: '33',
    RandMerchantBankRmb: '34',
    AccessBankGrobank: '31'
} as const;
export type IAPBANKNAME = typeof IAPBANKNAME[keyof typeof IAPBANKNAME];


export function IAPBANKNAMEFromJSON(json: any): IAPBANKNAME {
    return IAPBANKNAMEFromJSONTyped(json, false);
}

export function IAPBANKNAMEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPBANKNAME {
    return json as IAPBANKNAME;
}

export function IAPBANKNAMEToJSON(value?: IAPBANKNAME | null): any {
    return value as any;
}

